import React from 'react';
import { withStyles } from '@material-ui/core/styles';

class Header extends React.Component {
    constructor (props) {
        super(props);
    }

    render () {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <img src="https://images.landhawk.uk/logos/lh-logo.svg" className={classes.image} onClick={(e) => { window.location.replace('/'); }} />
            </div>
        );
    }
}

const styles = (theme) => ({
    root: {
        width: '100%',
        height: theme.constants.header,
        backgroundColor: theme.palette.primary.main,
        paddingLeft: '20px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center'
    },
    image: {
        cursor: 'pointer'
    }
});

export default withStyles(styles)(Header);